import * as React from "react";
import Slider, {Settings} from "react-slick";

type SlideItem = {
    image: string,
    thumbnail: string,
    alt: string,
    text: string
}

const items : SlideItem[] = [
    {
        image: "/images/miyaokaclinic_pic1.jpg",
        thumbnail: "/images/miyaokaclinic_thumbnail_pic1.jpg",
        alt: "宮岡クリニック：外観",
        text: "外観"
    },
    {
        image: "/images/miyaokaclinic_pic2.jpg",
        thumbnail: "/images/miyaokaclinic_thumbnail_pic2.jpg",
        alt: "宮岡クリニック：受付",
        text: "受付"
    },
    {
        image: "/images/miyaokaclinic_pic3.jpg",
        thumbnail: "/images/miyaokaclinic_thumbnail_pic3.jpg",
        alt: "宮岡クリニック：待合室",
        text: "待合室"
    },
    {
        image: "/images/miyaokaclinic_pic4.jpg",
        thumbnail: "/images/miyaokaclinic_thumbnail_pic4.jpg",
        alt: "宮岡クリニック：診察室",
        text: "診察室"
    },
    {
        image: "/images/miyaokaclinic_pic5.jpg",
        thumbnail: "/images/miyaokaclinic_thumbnail_pic5.jpg",
        alt: "宮岡クリニック：点滴室",
        text: "点滴室"
    },
    {
        image: "/images/miyaokaclinic_pic6.jpg",
        thumbnail: "/images/miyaokaclinic_thumbnail_pic6.jpg",
        alt: "宮岡クリニック：内視鏡検査室",
        text: "内視鏡検査室"
    },
    {
        image: "/images/miyaokaclinic_pic7.jpg",
        thumbnail: "/images/miyaokaclinic_thumbnail_pic7.jpg",
        alt: "宮岡クリニック：レントゲン室",
        text: "レントゲン室"
    },
];

const settings: Settings = {
    customPaging(index: number): JSX.Element {
        const item = items[index];
        return <a>
            <img src={item.thumbnail} alt={item.alt}/>
        </a>
    },
    className: "slider",
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear"
}

const SlideShow : React.FC = () => {
    return  <div>
        <h1>外観・院内風景</h1>
        {/* @ts-expect-error Async Server Component */}
        <Slider {...settings}>
            {items.map((item, index) => (
                <div key={index}>
                    <img src={item.image} alt={item.alt}/>
                    <div className={"text"}>
                        {item.text}
                    </div>
                </div>
            ))}
        </Slider>
    </div>
}

export default SlideShow;
